import { Trans } from '@lingui/macro';
import { Tab, Tabs } from '@material-ui/core';
import Panel from '../../page-framework/panel/PanelDecorator';
import CollectorsAdminCollectorListPanel from './CollectorsAdminCollectorListPanel';
import CollectorsAdminIpScopeListPanel from './CollectorsAdminIpScopeListPanel';
import { TAB_COLLECTORS, TAB_IPSCOPES } from './CollectorsAdminConstants';

function CollectorsAdminMainPanel({
    setActionsDisabled,
    setTableSelection,
    setTableState,
    triggerRef,
    activeTab,
    setActiveTab,
    ipScopeScan,
    setIpScopeScan,
    setCollectorCanDelete,
    setSelectedCollectors,
}) {
    const handleTabChange = (tab) => {
        if (tab === null) return;

        setActiveTab(tab);
        setIpScopeScan(null);
    };

    return (
        <>
            <Tabs value={activeTab} onChange={(e, index) => handleTabChange(index)} aria-label="collectors admin tabs">
                <Tab
                    id="collectors-admin-tab-collectors-list"
                    label={<Trans>Collectors</Trans>}
                    value={TAB_COLLECTORS}
                />
                <Tab id="collectors-admin-tab-ipscopes-list" label={<Trans>IP Scopes</Trans>} value={TAB_IPSCOPES} />
            </Tabs>
            {activeTab === TAB_COLLECTORS && (
                <CollectorsAdminCollectorListPanel
                    setActionsDisabled={setActionsDisabled}
                    setTableSelection={setTableSelection}
                    setTableState={setTableState}
                    triggerRef={triggerRef}
                    setCollectorCanDelete={setCollectorCanDelete}
                    setSelectedCollectors={setSelectedCollectors}
                />
            )}
            {activeTab === TAB_IPSCOPES && (
                <CollectorsAdminIpScopeListPanel
                    setActionsDisabled={setActionsDisabled}
                    setTableSelection={setTableSelection}
                    setTableState={setTableState}
                    triggerRef={triggerRef}
                    ipScopeScan={ipScopeScan}
                />
            )}
        </>
    );
}

export default Panel({
    typeAlias: 'CollectorsAdminMainPanel',
    filters: {
        required: [],
        optional: [],
    },
})(CollectorsAdminMainPanel);
